// Sentry first, so errors during app startup are captured (no-op without DSN)
import "./lib/sentry";
import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ReactDOM from "react-dom/client";
import { Toaster } from "react-hot-toast";
import { BrowserRouter } from "react-router-dom";
import { TooltipProvider } from "@/components/ui/tooltip";
import App from "./App";
import "./styles/index.css";

// Initialize i18n
import "./i18n";

// Enable axe-core in development
if (import.meta.env.DEV) {
  import("@axe-core/react").then((axe) => {
    axe.default(React, ReactDOM, 1000);
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <TooltipProvider>
          <App />
          <Toaster
            position="top-right"
            containerClassName="toast-container"
            toastOptions={{
              duration: 4000,
              style: {
                background: "var(--toast-bg, #fff)",
                color: "var(--toast-color, #1f2937)",
                border: "1px solid var(--toast-border, #e5e7eb)",
              },
              success: {
                style: {
                  background: "var(--toast-bg, #fff)",
                  color: "var(--toast-color, #1f2937)",
                  border: "1px solid var(--toast-border, #e5e7eb)",
                },
                iconTheme: {
                  primary: "#22c55e",
                  secondary: "#fff",
                },
              },
              error: {
                style: {
                  background: "var(--toast-bg, #fff)",
                  color: "var(--toast-color, #1f2937)",
                  border: "1px solid var(--toast-border, #e5e7eb)",
                },
                iconTheme: {
                  primary: "#ef4444",
                  secondary: "#fff",
                },
              },
            }}
          />
        </TooltipProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
